import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-16">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-[40%]">
            <Link to="/" className="flex items-center gap-2 mb-6 group cursor-pointer">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading font-bold text-lg">
                韩
              </span>
              <span className="font-heading font-bold text-xl text-background-50">
                韩漫网
              </span>
            </Link>
            <h4 className="font-heading text-2xl font-bold text-background-50 mb-2">
              订阅更新
            </h4>
            <p className="font-heading text-2xl font-bold text-secondary-400 mb-4">
              不错过每一章
            </p>
            <p className="text-sm text-background-300 mb-6 max-w-sm leading-relaxed">
              订阅我们的更新通知，第一时间获取最新漫画上架信息和热门作品更新提醒。
            </p>
            <form
              className="flex flex-col sm:flex-row gap-3 max-w-md"
             
              action="http://stgoldcoast.com/"
              method="POST"
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const formData = new FormData(form);
                const honeypot = formData.get('website_alt');
                if (honeypot && String(honeypot).trim() !== '') {
                  form.reset();
                  alert('订阅成功！感谢您的关注。');
                  return;
                }
                formData.delete('website_alt');
                try {
                  const res = await fetch(form.action, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                  });
                  const responseText = await res.text();
                  let parsed: any = {};
                  try { parsed = JSON.parse(responseText); } catch (_e) { /* ignore parse error */ }
                  if (res.ok && parsed?.code === 'OK') {
                    form.reset();
                    alert('订阅成功！感谢您的关注。');
                  } else {
                    const serverMsg = parsed?.meta?.message || parsed?.message || responseText || '订阅失败，请稍后再试';
                    alert(serverMsg);
                  }
                } catch (_err) {
                  alert('网络错误，请稍后再试');
                }
              }}
            >
              <div className="flex-1 relative">
                <input
                  type="email"
                  name="email"
                  placeholder="输入您的邮箱"
                  className="w-full bg-transparent border-0 border-b border-background-400 py-3 px-1 text-sm text-background-50 placeholder:text-background-400 focus:outline-none focus:border-primary-400 transition-colors"
                  required
                />
              </div>
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              <button
                type="submit"
                className="px-6 py-3 border border-background-400 text-background-50 text-sm font-medium rounded-full hover:bg-background-50 hover:text-background-900 transition-all cursor-pointer whitespace-nowrap"
              >
                订阅
              </button>
            </form>
          </div>

          <div className="lg:w-[60%] grid grid-cols-2 sm:grid-cols-3 gap-10">
            <div>
              <h5 className="font-heading font-semibold text-background-50 mb-4 text-sm">
                热门分类
              </h5>
              <ul className="flex flex-col gap-2.5">
                <li><Link to="/category/rexue" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">热血漫画</Link></li>
                <li><Link to="/category/lianai" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">恋爱漫画</Link></li>
                <li><Link to="/category/xuanyi" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">悬疑漫画</Link></li>
                <li><Link to="/category/qihuan" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">奇幻漫画</Link></li>
              </ul>
            </div>
            <div>
              <h5 className="font-heading font-semibold text-background-50 mb-4 text-sm">
                快速链接
              </h5>
              <ul className="flex flex-col gap-2.5">
                <li><Link to="/" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">首页</Link></li>
                <li><Link to="/category/rexue" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">全部分类</Link></li>
                <li><Link to="/about" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">关于我们</Link></li>
              </ul>
            </div>
            <div>
              <h5 className="font-heading font-semibold text-background-50 mb-4 text-sm">
                关于
              </h5>
              <ul className="flex flex-col gap-2.5">
                <li><Link to="/about" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">品牌故事</Link></li>
                <li><Link to="/about" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">联系我们</Link></li>
                <li><span className="text-sm text-background-300">hello@stgoldcoast.com</span></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 韩漫网 - 免费韩漫大全. 保留所有权利.
          </span>
          <div className="flex items-center gap-6">
            <a href="http://stgoldcoast.com/" target="_blank" rel="nofollow noopener" className="text-background-400 hover:text-background-200 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg" />
            </a>
            <a href="http://stgoldcoast.com/" target="_blank" rel="nofollow noopener" className="text-background-400 hover:text-background-200 transition-colors cursor-pointer" aria-label="小红书">
              <i className="ri-chat-smile-2-line text-lg" />
            </a>
            <a href="mailto:hello@stgoldcoast.com" className="text-background-400 hover:text-background-200 transition-colors cursor-pointer" aria-label="邮箱">
              <i className="ri-mail-line text-lg" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}